import { ROUTES } from "../routes/User/paths";

export const { REACT_APP_NAME, REACT_APP_API_BASE_URL, REACT_APP_STRIPE_PUBLIC_KEY } = process.env;

export const REACT_APP_AFTER_LOGIN_REDIRECT_URL = ROUTES.dashboard;
export const REACT_APP_BEFORE_LOGIN_REDIRECT_URL = ROUTES.login;

export const SNACKBAR_VARIANT = {
  SUCCESS: "success",
  ERROR: "error",
  DEFAULT: "default",
};

export const CHAT_ROOMS = Object.freeze({
  TYPES: {
    SINGLE: "single",
    GROUP: "group",
  },
  STATUS: {
    PRIVATE: "private",
    PUBLIC: "public",
  },
  JOIN_REQUEST: {
    APPROVED: "approved",
    REJECTED: "rejected",
  },
});

export const MESSAGE_SENDER_TYPE = Object.freeze({
  SELF: "self",
  OTHER: "other",
});

export const ONLINE_STATUS = Object.freeze({
  ONLINE: "online",
  OFFLINE: "offline",
});

export const MESSAGE_FILE_TYPES = Object.freeze({
  TEXT: "text",
  AUDIO: "audio",
  VIDEO: "video",
  IMAGE: "image",
  DOCUMENT: "document",
});

export const MESSAGE_INTERACTIONS_TYPES = Object.freeze({
  LIKE: "like",
  DISLIKE: "dislike",
});

export const ROOM_MODES = Object.freeze({
  SPECTATOR: "spectator",
  REGULAR: "regular",
});

export const ROOM_EXPIRED_VALUE = 'Expired';

export const TRANSACTION_STATUS = Object.freeze({
  SUCCESS: "success",
  FAILED: "failed",
});